(() => {
  if (customElements.get('modal-upsell')) {
    return;
  }

  class modalUpsell extends HTMLElement {
    constructor() {
      super();

      this.modal = this;
      this.close = this.querySelector('.close');
      this.cookieName = this.dataset.upsellCookie;
      this.cookieActive = getCookie(this.cookieName);

      this.closeModalOnClicks();
    }

    openModal(delay = 0) {
      // if (getCookie(this.cookieName) === null) {
        if (this.modal) {
          setTimeout(() => {
            this.modal.classList.add('upsell-modal--active');
          }, delay);
        }
      // }
    }

    closeModal() {
      if (this.modal) {
        this.modal.classList.remove('upsell-modal--active');
        setCookie(this.cookieName, 'none', 1);
      }
    }

    closeModalOnClicks(){
      let self = this;
      let closeBtn = self.querySelector('.modal__btn-close');
      let atcButtons = self.querySelectorAll('.main-product__form-submit');

      closeBtn.onclick = function() {
        self.closeModal();
      }

      window.onclick = function(event) {
        if (event.target == self.modal) {
          self.closeModal();
        }
      }
      self.close.addEventListener('click', () => {
        self.closeModal();
      })

      atcButtons.forEach(button => {
        button.onclick = function(event) {
          setTimeout(() => {
            self.closeModal();
          }, 500);
        }
      });

    }
  }

  customElements.define('modal-upsell', modalUpsell);
})();
